import styled from 'styled-components';
export var HeaderInner = styled.header.withConfig({
  displayName: "HeaderInner",
  componentId: "sc-1scmjyb-0"
})(["margin:18px 0;"]);